import { createContext, useContext, useEffect, useState } from "react";

export const LANGUAGES = [
  { code: "EN", label: "English",  flag: "🇬🇧" },
  { code: "FR", label: "Français", flag: "🇫🇷" },
  { code: "AR", label: "العربية",   flag: "🇲🇦" },
  { code: "ES", label: "Español",  flag: "🇪🇸" },
];

const STORAGE_KEY = "yaba_lang";
const LanguageContext = createContext({ lang: "EN", setLang: () => {} });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "EN";
    return window.localStorage.getItem(STORAGE_KEY) || "EN";
  });

  useEffect(() => {
    if (typeof document === "undefined") return;
    document.documentElement.setAttribute("lang", lang.toLowerCase());
    document.documentElement.setAttribute("dir", lang === "AR" ? "rtl" : "ltr");
  }, [lang]);

  const setLang = (code) => {
    setLangState(code);
    try {
      window.localStorage.setItem(STORAGE_KEY, code);
    } catch {}
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
